export interface PatternInterface {
    onlyLettersPattern : string;
    lettersNumbersSpacePattern : string;
    lettNumSpaceParentSingQuoPattern : string;
    urlPattern : string;
    onlyNumbersPattern : any;
    codigoPostalPattern : any;
}

export class PatternClass implements PatternInterface {
    public onlyLettersPattern = "^[ a-zA-ZÀ-ÿ\u00f1\u00d1\.]*$";
    public lettersNumbersSpacePattern = "^[ a-zA-ZÀ-ÿ0-9\u00f1\u00d1\.\#]*$";
    public lettNumSpaceParentSingQuoPattern = "^[ a-zA-ZÀ-ÿ0-9()\'\u00f1\u00d1]*$"
    public urlPattern = "www\.[a-zA-Z0-9-]{3,63}\.com";
    public onlyNumbersPattern = /^(?=.*\d)[\d ]+$/;
    public codigoPostalPattern = /^\d{4,5}/;
    public textAreasPattern = "^[ a-zA-ZÀ-ÿ0-9\u00f1\u00d1\.\#\n:]*$";
    public textAreasPatternSolicitudes = "^[ a-zA-ZÀ-ÿ0-9:*/¿?!¡$%&()=;@',{}_\u00f1\u00d1\.\#\n\+\"\-]*$";
}